import {Route} from "./Route.ts";
import {Generics} from "../components/generics.ts";

export const routes: Route[] = [
    {
        path: "",
        title: "Bingo",
        aliases: ["/"],
        template: Generics.bingo,
        allowWithoutLogin: true
    }
];